import { useCallback } from 'react'

type MaybeGeneratedImage =
	| {
		meta?: { is_generated?: boolean | null } | null
	}
	| null
	| undefined

export function useIsImageGenerated() {
	return useCallback((image: MaybeGeneratedImage): boolean => {
		if (!image) { return true }

		if (!image.meta) { return true }
		if (typeof image.meta.is_generated === 'boolean') {
			return image.meta.is_generated
		}

		return true
	}, [])
}
